var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.78 2.58002L10.6 1.40002L4 8.00002L10.6 14.6L11.78 13.42L6.36 8.00002L11.78 2.58002Z",
    fill: "#575E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenuClose);
export default __webpack_public_path__ + "static/media/arrow_menu_close.005dd98152f121881d568b68ac611098.svg";
export { ForwardRef as ReactComponent };